import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandCucumberIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cucumber",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 10.99c-.01 5.52 -4.48 10 -10 10.01v-2.26l-.01 -.01c-4.28 -1.11 -6.86 -5.47 -5.76 -9.75a8 8 0 0 1 9.74 -5.76c3.53 .91 6.03 4.13 6.03 7.78v-.01z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10.5 8l-.5 -1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13.5 14l.5 1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 12.5l-1 .5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 14l-.5 1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13 8l.5 -1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 12.5l-1 -.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 10l-1 -.5"
    }, null), _createTextVNode(" ")]);
  }
};